import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Breadcrumbs } from '@mui/material'
import { Text } from '@pbt/pbt-ui-components'

interface BreadcrumbItem {
  label: string
  path?: string
}

interface OrderItemsPageBreadcrumbsProps {
  itemName?: string
  orderId: string
  orderNumber: string
}

export const OrderItemsPageBreadcrumbs = ({
  itemName,
  orderId,
  orderNumber,
}: OrderItemsPageBreadcrumbsProps) => {
  const navigate = useNavigate()
  const { t } = useTranslation('Admin')

  const breadcrumbItems: BreadcrumbItem[] = [
    {
      label: t('Admin:CATALOG.ORDERS.ORDERS_LABEL'),
      path: '/admin/catalog/inventories/orders',
    },
    {
      label: t('Admin:CATALOG.ORDERS.RECEIVE_ORDER_TITLE', {
        orderNumber,
      }),
      path: `/admin/catalog/inventories/orders/${orderId}`,
    },
  ]

  if (itemName) {
    breadcrumbItems.push({
      label: t('Admin:CATALOG.ORDERS.RECEIVE_ITEM_TITLE', { itemName }),
    })
  }

  const handleClick = (path?: string) => {
    if (path) {
      navigate(path)
    }
  }

  return (
    <Breadcrumbs
      separator=">"
      sx={{
        display: 'flex',
        alignItems: 'center',
        backgroundColor: (theme) => theme.colors.grayGray4,
        height: (theme) => theme.spacing(5),
        py: 1,
        px: 2,
      }}
    >
      {breadcrumbItems.map(({ label, path }, index) =>
        index === breadcrumbItems.length - 1 ? (
          <Text aria-current="page" key={label} variant="body2">
            {label}
          </Text>
        ) : (
          <Text
            link
            key={label}
            variant="body2"
            onClick={() => handleClick(path)}
          >
            {label}
          </Text>
        ),
      )}
    </Breadcrumbs>
  )
}
